import React, { useState, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Collapse from "@material-ui/core/Collapse";
import Avatar from "@material-ui/core/Avatar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import { red } from "@material-ui/core/colors";
import FavoriteIcon from "@material-ui/icons/Favorite";
import ShareIcon from "@material-ui/icons/Share";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { LocalMall } from "@material-ui/icons";
import { Badge, Grid } from "@material-ui/core";

import { showComponentInDev, isFavorate } from "../../helpers";
// import ProductCheckbox from "./ProductCheckbox";
import ProductCheckbox from "./ProductCheckbox";
import { UserContext } from "../../context";
import { updateDataWithId } from "../../services/firestore";
import { gsGetUrl } from "../../services/firestorage";
import { isDev } from "../../helpers";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";

const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
        maxWidth: 400,
    },
    media: {
        height: 0,
        paddingTop: "56.25%", // 16:9
    },
    expand: {
        transform: "rotate(0deg)",
        marginLeft: "auto",
        transition: theme.transitions.create("transform", {
            duration: theme.transitions.duration.shortest,
        }),
    },
    expandOpen: {
        transform: "rotate(180deg)",
    },
    avatar: {
        backgroundColor: red[500],
    },
}));

export default function RecipeReviewCard(props) {
    const classes = useStyles();
    const { user, setUser } = useContext(UserContext);
    const { name, imgSrc, DE, EN, sub, subheader } = props;

    const [expanded, setExpanded] = useState(false);
    const [imgURL, setImgURL] = useState(null);

    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    const [showDetailImg, setShowDetailImg] = useState(false);

    const toggleFavorate = (name, favorite) => {
        if (!isFavorate(name, favorite)) {
            console.log("Add favorite", favorite, name);
            let newFavorate = [...user.favorite, name];
            updateDataWithId({
                collection: isDev ? "devUsers" : "users",
                id: user.uid,
                content: { favorite: newFavorate },
            });
            setUser({ ...user, favorite: newFavorate });
        } else {
            let newFavorate = user.favorite.filter((item) => item !== name);
            updateDataWithId({
                collection: isDev ? "devUsers" : "users",
                id: user.uid,
                content: { favorite: newFavorate },
            });
            setUser({
                ...user,
                favorite: newFavorate,
            });
        }
    };

    if (imgSrc) gsGetUrl(imgSrc).then((url) => setImgURL(url));

    return (
        <Card className={classes.root}>
            <CardHeader title={name} subheader={subheader} />
            {imgURL ? (
                <CardMedia
                    className={classes.media}
                    image={imgURL}
                    title={name}
                    onClick={() => setShowDetailImg(true)}
                />
            ) : null}
            {imgURL && showDetailImg && (
                <Lightbox
                    mainSrc={imgURL}
                    onCloseRequest={() => setShowDetailImg(false)}
                />
            )}
            <CardContent>
                <Typography
                    variant="body1"
                    gutterBottom
                    color="textSecondary"
                    component="p"
                >
                    {DE}
                </Typography>
                {EN ? (
                    <React.Fragment>
                        <hr />
                        <Typography
                            variant="body1"
                            gutterBottom
                            color="textSecondary"
                            component="p"
                        >
                            {EN}
                        </Typography>
                    </React.Fragment>
                ) : null}
            </CardContent>
            <CardActions disableSpacing>
                <IconButton aria-label="buy" onClick={handleExpandClick}>
                    <Badge badgeContent="+" color="secondary">
                        <LocalMall />
                    </Badge>
                </IconButton>
                <IconButton
                    aria-label="add to favorites"
                    onClick={() => toggleFavorate(name, user.favorite)}
                >
                    <FavoriteIcon
                        color={
                            user.favorite && isFavorate(name, user.favorite)
                                ? "secondary"
                                : undefined
                        }
                    />
                </IconButton>
                {showComponentInDev(
                    <IconButton aria-label="share">
                        <ShareIcon />
                    </IconButton>
                )}
                <Grid
                    container
                    direction="row"
                    justify="flex-end"
                    onClick={handleExpandClick}
                >
                    <IconButton
                        className={clsx(classes.expand, {
                            [classes.expandOpen]: expanded,
                        })}
                        aria-expanded={expanded}
                        aria-label="show more"
                    >
                        <ExpandMoreIcon />
                    </IconButton>
                </Grid>
            </CardActions>
            <Collapse in={expanded} timeout="auto" unmountOnExit>
                <CardContent>
                    <ProductCheckbox mainName={name} subitems={sub} />
                </CardContent>
            </Collapse>
        </Card>
    );
}
